var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.52 2.65557C22.389 2.14135 22.1323 1.6724 21.7756 1.29567C21.4188 0.91894 20.9744 0.647638 20.4869 0.508917C18.6926 1.06661e-07 11.5 0 11.5 0C11.5 0 4.30737 -1.06661e-07 2.51306 0.50621C2.02539 0.644481 1.5808 0.915632 1.22394 1.29243C0.867087 1.66923 0.610525 2.13842 0.480022 2.65287C-1.01143e-07 4.54777 0 8.5 0 8.5C0 8.5 -1.01143e-07 12.4522 0.480022 14.3444C0.74442 15.3893 1.52478 16.2123 2.51306 16.4911C4.30737 17 11.5 17 11.5 17C11.5 17 18.6926 17 20.4869 16.4911C21.4778 16.2123 22.2556 15.3893 22.52 14.3444C23 12.4522 23 8.5 23 8.5C23 8.5 23 4.54777 22.52 2.65557ZM9.2154 12.1274V4.87261L15.1708 8.47293L9.2154 12.1274Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.d005505f460ed8f27516386b315ddaf7.svg";
export { ForwardRef as ReactComponent };